<template>
    <b-tabs content-class="mt-3"
            v-model="tab"
            fill
    >
        <b-tab title="Categorías 1 y 2" active>
            <answers ref="answers"
                     code_question_group="GQ07"
                     danger_code="MCAL28"
                     v-if="tab === 0"
            />
        </b-tab>
        <b-tab title="Categoría adicional para los efectos sobre o a través de la lactancia">
            <answers ref="answers"
                     code_question_group="GQ08"
                     danger_code="MCAL29"
                     v-if="tab === 1"
            />
        </b-tab>
    </b-tabs>
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    data(){
        return {
            tab: 0
        }
    }
};
</script>
